import {ReactNode} from 'react'
import clsx from 'clsx'

type DivProps = React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>

export interface DrawerHeaderProps extends DivProps {
  children: ReactNode
}

export const DrawerHeader = ({children, className, ...otherProps}: DrawerHeaderProps) => {
  return (
    <div className={clsx('drawer-header', className)} {...otherProps}>
      {children}
    </div>
  )
}
